var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1514_12386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0177 12.7296H4.94141C4.65906 12.7296 4.40418 12.8977 4.29248 13.1566L1.31299 20.0943L8.38892 16.4804C7.54187 15.3083 6.7038 14.0156 6.0177 12.7296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7073 13.1566C19.5958 12.8977 19.3408 12.7296 19.0586 12.7296H17.9823C16.6866 15.1576 14.799 17.6667 13.5982 19.0471C12.7537 20.0158 11.2453 20.0147 10.4021 19.0471C10.3159 18.9481 9.8656 18.4268 9.24542 17.6251L7.96973 18.277L12.7953 23.0932L21.9388 18.353L19.7073 13.1566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.442563 22.1218L0.0576758 23.0181C-0.141543 23.4819 0.199766 23.9999 0.706418 23.9999H11.0682C11.133 23.9518 11.1337 23.9547 11.4816 23.7743L6.64892 18.9517L0.442563 22.1218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9426 23.0182L22.4968 19.6516L14.1091 24H23.2939C23.7994 24 24.1422 23.4829 23.9426 23.0182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7059 6.34322C12.7059 5.95467 12.3892 5.63882 12.0001 5.63882C11.6108 5.63882 11.2942 5.95467 11.2942 6.34322C11.2942 6.73159 11.6108 7.04763 12.0001 7.04763C12.3892 7.04763 12.7059 6.73159 12.7059 6.34322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5328 18.0758C12.7704 17.803 18.3528 11.3456 18.3528 6.90671C18.3528 -2.24637 5.64746 -2.35806 5.64746 6.90671C5.64746 11.3456 11.2298 17.803 11.4675 18.0758C11.7489 18.3986 12.2519 18.3982 12.5328 18.0758ZM9.88251 6.3433C9.88251 5.17801 10.8325 4.23007 12.0001 4.23007C13.1676 4.23007 14.1176 5.17801 14.1176 6.3433C14.1176 7.5084 13.1676 8.45633 12.0001 8.45633C10.8325 8.45633 9.88251 7.5084 9.88251 6.3433Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1514_12386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d03678d67d1409240e96182e3223376a.svg";
export { ForwardRef as ReactComponent };